import Vue from 'vue';
import i18n from '@/i18n'
Vue.filter('country', function (value) {
    if (!value) return '';
    value = value.toString();
    return i18n.t('countries.' + value)
})